import { forwardRef } from 'react'
import type { Settings } from 'react-slick'
import SlickSlider from 'react-slick'

interface ArrowProps {
  className?: string
  style?: React.CSSProperties
  onClick?: () => void
  slidesToShow?: number
  infinite?: boolean
  currentSlide?: number
  slideCount?: number
}

const PrevArrow = ({
  className,
  style,
  onClick,
  currentSlide = 0,
  infinite = false,
}: ArrowProps) => {
  if (!infinite && !currentSlide) {
    return null
  }

  return (
    <svg
      style={style}
      onClick={onClick}
      width='44'
      height='44'
      viewBox='0 0 44 44'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={`${className} swpNav z-10 opacity-0 transition-opacity duration-300 before:!hidden group-hover:opacity-100`}
    >
      <g filter='url(#filter0_d_808_4171)'>
        <circle cx='22' cy='18' r='18' fill='white' />
      </g>
      <path
        d='M25.41 13.41L24 12L18 18L24 24L25.41 22.59L20.83 18L25.41 13.41Z'
        fill='black'
      />
      <defs>
        <filter
          id='filter0_d_808_4171'
          x='0'
          y='0'
          width='44'
          height='44'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_808_4171'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_808_4171'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}

const NextArrow = ({
  className,
  style,
  onClick,
  slidesToShow = 1,
  infinite = false,
  currentSlide = 0,
  slideCount,
}: ArrowProps) => {
  if (!infinite && currentSlide + slidesToShow === slideCount) {
    return null
  }

  return (
    <svg
      width='44'
      height='44'
      viewBox='0 0 44 44'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={`${className} swpNav z-10 opacity-0 transition-opacity duration-300 before:!hidden group-hover:opacity-100`}
      style={style}
      onClick={onClick}
    >
      <g filter='url(#filter0_d_808_4175)'>
        <circle
          cx='18'
          cy='18'
          r='18'
          transform='matrix(-1 0 0 1 40 0)'
          fill='white'
        />
      </g>
      <path
        d='M18.59 13.41L20 12L26 18L20 24L18.59 22.59L23.17 18L18.59 13.41Z'
        fill='black'
      />
      <defs>
        <filter
          id='filter0_d_808_4175'
          x='0'
          y='0'
          width='44'
          height='44'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_808_4175'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_808_4175'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}

const Slider = forwardRef<SlickSlider, Settings>((props, ref) => {
  return (
    <div className='relative'>
      <SlickSlider
        {...props}
        className={`${props.className} slider-with-arrow group !static overflow-hidden`}
        ref={ref}
        nextArrow={
          <NextArrow
            slidesToShow={props.slidesToShow || 1}
            infinite={props.infinite}
          />
        }
        prevArrow={<PrevArrow infinite={props.infinite} />}
      />
    </div>
  )
})

Slider.displayName = 'Slider'

export default Slider
